import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mileageContainer", "ownersContainer", "newCarRadio"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const isNewCar = this.newCarRadioTargets.find(radio => radio.checked)?.value === "true"
    const containers = [this.mileageContainerTarget, this.ownersContainerTarget]

    if (isNewCar) {
      containers.forEach(container => {
        container.classList.add("hidden")
        this.disableAndClearInputs(container)
      })
    } else {
      containers.forEach(container => {
        container.classList.remove("hidden")
        this.enableInputs(container)
      })
    }
  }

  disableAndClearInputs(container) {
    container.querySelectorAll("input, select").forEach(input => {
      input.disabled = true
      input.value = ""
      input.dispatchEvent(new Event("change"))
    })
  }

  enableInputs(container) {
    container.querySelectorAll("input, select").forEach(input => {
      input.disabled = false
    })
  }
}
